module.exports = __webpack_public_path__ + "img/event-4.3b9c25f5.png";